// Solid (filled) icons for the Updates page, backed by the real Hugeicons Pro
// solid-rounded set (@hugeicons-pro/core-solid-rounded), rendered through the
// official <HugeiconsIcon> component.
//
// The wrapper components keep a stable { className } API so call sites
// (UpdatesPage) don't care that they're Hugeicons underneath — and if the icon
// source ever changes again, only this file moves. `className` sets size + color
// (Tailwind h-*/w-*/text-*), which CSS-overrides HugeiconsIcon's defaults;
// solid paths inherit `currentColor`.
//
// Requires the HUGEICONS_TOKEN env var at install time (see .npmrc / .env.local).
import { HugeiconsIcon } from '@hugeicons/react'
import {
  AppleIcon,
  MicrosoftIcon,
  Rocket01Icon,
  SparklesIcon,
  CheckmarkCircle02Icon,
  Wrench01Icon,
  FlashIcon,
  PaintBoardIcon,
  Shield01Icon,
  DotIcon,
  ArrowUpRight01Icon,
} from '@hugeicons-pro/core-solid-rounded'

function Icon({ icon, className }) {
  return <HugeiconsIcon icon={icon} className={className} />
}

export function AppleSolid({ className }) { return <Icon icon={AppleIcon} className={className} /> }
export function WindowsSolid({ className }) { return <Icon icon={MicrosoftIcon} className={className} /> }
export function RocketSolid({ className }) { return <Icon icon={Rocket01Icon} className={className} /> }
export function SparkleSolid({ className }) { return <Icon icon={SparklesIcon} className={className} /> }
export function CheckCircleSolid({ className }) { return <Icon icon={CheckmarkCircle02Icon} className={className} /> }
export function WrenchSolid({ className }) { return <Icon icon={Wrench01Icon} className={className} /> }
export function FlashSolid({ className }) { return <Icon icon={FlashIcon} className={className} /> }
export function PaletteSolid({ className }) { return <Icon icon={PaintBoardIcon} className={className} /> }
export function ShieldSolid({ className }) { return <Icon icon={Shield01Icon} className={className} /> }
export function DotSolid({ className }) { return <Icon icon={DotIcon} className={className} /> }
export function ArrowUpRightSolid({ className }) { return <Icon icon={ArrowUpRight01Icon} className={className} /> }

// Category icon lookup for a change entry `type`.
export function ChangeTypeIcon({ type, className }) {
  switch (type) {
    case 'feat': return <SparkleSolid className={className} />
    case 'fix': return <WrenchSolid className={className} />
    case 'perf': return <FlashSolid className={className} />
    case 'style': return <PaletteSolid className={className} />
    case 'security': return <ShieldSolid className={className} />
    default: return <DotSolid className={className} />
  }
}
